export const SET_SEARCH = 'SET_SEARCH';
export const SET_TERMS = 'SET_TERMS';
